// Moved to components/Table/DataTable — nothing here was subscriptions-specific.
//
// Two things the copy here owned now live in the shared table: dot-notation field paths
// ('user.email'), which it resolved itself, and the pinned header, now the `stickyHeader`
// prop. Row clicks moved from a baked-in handleClick('display', id) to the generic
// `onRowClick`, so the 'display' action name stays in the container where it means
// something.
export { default } from '../../Table/DataTable';
